import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'object-dialog',
  templateUrl: './object-dialog.component.html',
  styleUrls: ['./object-dialog.component.scss'],
})
export class ObjectDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
